// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://plasmascan.to/address/0x061D8e131F26512348ee5FA42e2DF1bA9d6505E9
export const POOL_ADDRESSES_PROVIDER = '0x061D8e131F26512348ee5FA42e2DF1bA9d6505E9';

// IPool https://plasmascan.to/address/0x925a2A7214Ed92428B5b1B090F80b25700095e12
export const POOL = '0x925a2A7214Ed92428B5b1B090F80b25700095e12';

// IPoolConfigurator https://plasmascan.to/address/0xc022B6c71c30A8Ad52Dac504eFA132d13D99d2D9
export const POOL_CONFIGURATOR = '0xc022B6c71c30A8Ad52Dac504eFA132d13D99d2D9';

// IAaveOracle https://plasmascan.to/address/0x33E0b3fc976DC9C516926BA48CfC0A9E10a2aAA5
export const ORACLE = '0x33E0b3fc976DC9C516926BA48CfC0A9E10a2aAA5';

// https://plasmascan.to/address/0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A
export const ACL_ADMIN = '0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A';

// IACLManager https://plasmascan.to/address/0xa860355F0ccFdC823F7332ac108317b2a1509C06
export const ACL_MANAGER = '0xa860355F0ccFdC823F7332ac108317b2a1509C06';

// IPoolDataProvider https://plasmascan.to/address/0xf2D6E38B407e31E7E7e4a16E6769728b76c7419F
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xf2D6E38B407e31E7E7e4a16E6769728b76c7419F';

// https://plasmascan.to/address/0x2F762D4b63bd3c0e4E13D716E8BC8a49F95dCf09
export const POOL_IMPL = '0x2F762D4b63bd3c0e4E13D716E8BC8a49F95dCf09';

// https://plasmascan.to/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://plasmascan.to/address/0x3A57eAa3Ca3794D66977326af7991eB3F6dD5a5A
export const DEFAULT_INCENTIVES_CONTROLLER = '0x3A57eAa3Ca3794D66977326af7991eB3F6dD5a5A';

// https://plasmascan.to/address/0x5117F170716eCEAC8ef63d375bc7416Afa6f4497
export const EMISSION_MANAGER = '0x5117F170716eCEAC8ef63d375bc7416Afa6f4497';

// ICollector https://plasmascan.to/address/0x5E2d083417D12d4B0824E14Ecd48D26831F4Da7D
export const COLLECTOR = '0x5E2d083417D12d4B0824E14Ecd48D26831F4Da7D';

// https://plasmascan.to/address/0x2fFB265D591809FB1c4bAbA84996507E3C168406
export const DEFAULT_A_TOKEN_IMPL = '0x2fFB265D591809FB1c4bAbA84996507E3C168406';

// https://plasmascan.to/address/0x179C65343d5d2e21DCB2b4818Ab4ad0c93Fe879a
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x179C65343d5d2e21DCB2b4818Ab4ad0c93Fe879a';

// https://plasmascan.to/address/0x235d5ed464B3D0a7a616305FF6E71a2A06F82283
export const CONFIG_ENGINE = '0x235d5ed464B3D0a7a616305FF6E71a2A06F82283';

// https://plasmascan.to/address/0x98F756B77D6Fde14E08bb064b248ec7512F9f8ba
export const RISK_STEWARD = '0x98F756B77D6Fde14E08bb064b248ec7512F9f8ba';

// https://plasmascan.to/address/0xeE8Ba3464abcEeA6E34554d174DCbdd66083641b
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xeE8Ba3464abcEeA6E34554d174DCbdd66083641b';

// https://plasmascan.to/address/0xcb85C501B3A5e9851850d66648d69B26A4c90942
export const UI_INCENTIVE_DATA_PROVIDER = '0xcb85C501B3A5e9851850d66648d69B26A4c90942';

// https://plasmascan.to/address/0xdA549478Fd5C2BdB9e5eB000D0ff2554771598C7
export const UI_POOL_DATA_PROVIDER = '0xdA549478Fd5C2BdB9e5eB000D0ff2554771598C7';

// https://plasmascan.to/address/0x91FC11136d5615575a0fC5981Ab5C0C54418E2C6
export const WALLET_BALANCE_PROVIDER = '0x91FC11136d5615575a0fC5981Ab5C0C54418E2C6';

// https://plasmascan.to/address/0x54BDcc37c4143f944A3EE51C892a6cBDF305E7a0
export const WETH_GATEWAY = '0x54BDcc37c4143f944A3EE51C892a6cBDF305E7a0';

// https://plasmascan.to/address/0xbcb77d9D638abECB6BB910c1d8A4c24b0DD165A2
export const STATA_FACTORY = '0xbcb77d9D638abECB6BB910c1d8A4c24b0DD165A2';

// https://plasmascan.to/address/0x300f49ddf6fB9358ddCB22b12fFae62F1Cce9CdD
export const DUST_BIN = '0x300f49ddf6fB9358ddCB22b12fFae62F1Cce9CdD';

// https://plasmascan.to/address/0xAe48F22903d43f13f66Cc650F57Bd4654ac222cb
export const EDGE_RISK_ORACLE = '0xAe48F22903d43f13f66Cc650F57Bd4654ac222cb';

// https://plasmascan.to/address/0xe1472037C9f17Ac00bf5336272ab74e423B9254d
export const EDGE_RISK_STEWARD_PENDLE_EMODE = '0xe1472037C9f17Ac00bf5336272ab74e423B9254d';

// https://plasmascan.to/address/0x530034d1A739Afd261291B86A5c3b95eC30c4b44
export const EDGE_RISK_STEWARD_DISCOUNT_RATE = '0x530034d1A739Afd261291B86A5c3b95eC30c4b44';

// https://plasmascan.to/address/0xdD56dE44d2d79eC97cEa1A0049c767A4ce97953e
export const EDGE_INJECTOR_PENDLE_EMODE = '0xdD56dE44d2d79eC97cEa1A0049c767A4ce97953e';

// https://plasmascan.to/address/0x6E3748B753D38e33CC476aF63C9d220Af65b7fc4
export const EDGE_INJECTOR_DISCOUNT_RATE = '0x6E3748B753D38e33CC476aF63C9d220Af65b7fc4';

export const CHAIN_ID = 9745;
export const ASSETS = {
  USDT0: {
    decimals: 6,
    id: 0,
    UNDERLYING: '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
    A_TOKEN: '0x5D72a9d9A9510Cd8cBdBA12aC62593A58930a948',
    V_TOKEN: '0xCBBC427b5658672768E11BFDa00879839DB4785F',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0xdBbB0b5DD13E7AC9C56624834ef193df87b022c3',
    STATA_TOKEN: '0xE0126F0c4451B2B917064A93040fd4770D6774b5',
  },
  USDe: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    A_TOKEN: '0x7519403E12111ff6b710877Fcd821D0c12CAF43A',
    V_TOKEN: '0xEa650893085DAd858150915291645F57164A4257',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0xdBbB0b5DD13E7AC9C56624834ef193df87b022c3',
    STATA_TOKEN: '0xC63F1a8c0cD4493E18f6f3371182BE01Ce0BeF02',
  },
  sUSDe: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
    A_TOKEN: '0xC1A318493fF07a68fE438Cee60a7AD0d0DBa300E',
    V_TOKEN: '0xc7A92af2ca7b75FC608A8F0C08640dE5b339BfC0',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x40eE40D7332995CACA49Db46B94237Fa64647Bd4',
    STATA_TOKEN: '0xA31C7dDAD8F1D66D037C4EE76F8fb725f927Bc25',
  },
  XAUt0: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0x1B64B9025EEbb9A6239575dF9Ea4b9Ac46D4d193',
    A_TOKEN: '0x5c43D6C075C7CF95fb188FB2977eeD3E3F2a92c2',
    V_TOKEN: '0x20091c402C2933144Bd9a9B1B07dBEBf19c6d5A1',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x921371Fa4d4A30cD350D29762ccB8A5861724E29',
    STATA_TOKEN: '0x8AA32f47f375A4a1FC803e24f9AE42C57469c35F',
  },
  weETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xA3D68b74bF0528fdD07263c60d6488749044914b',
    A_TOKEN: '0xAf1a7a488c8348b41d5860C04162af7d3D38A996',
    V_TOKEN: '0x34542B95Efdf2dFbD59978C2F620FBd7275E9323',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0xA7786e3042435f88869e5a4e384B0AD6B009800b',
    STATA_TOKEN: '0x893dF8f4bBFEbC313Fc52a53E2e23487ACb28181',
  },
  WETH: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x9895D81bB462A195b4922ED7De0e3ACD007c32CB',
    A_TOKEN: '0xf1aB7f60128924d69f6d7dE25A20eF70bBd43d07',
    V_TOKEN: '0x638d7db63cd5c902bDd9A91cf195870551c3c7B3',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x43A7dd2125266c5c4c26EB86cd61241132426Fe7',
    STATA_TOKEN: '0xa047fdFb3420A27a5f926735b475fE5a1E968786',
  },
  PT_USDe_15JAN2026: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a',
    A_TOKEN: '0xEa601A9FECF80bFC529F08A51bD8Cb0d72fc862A',
    V_TOKEN: '0xD73253B18124837465b0c1fCB1A947d0542a991B',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x30cb6ff8649Cc02cEa91971D4730EebeD5A8D2F1',
  },
  PT_sUSDE_15JAN2026: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8',
    A_TOKEN: '0x0b9A412c94f07223752031f75a20DDe542D63d5C',
    V_TOKEN: '0xb2A5AD339d9687B5606b21B37F72f350e5BbC622',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x3eca1c7836eA09DB3dc85be7B5526Ce80E2609a1',
  },
  wstETH: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0xe48D935e6C9e735463ccCf29a7F11e32bC09136E',
    A_TOKEN: '0x140Bc58975DFba4D30fE65c4F6262a6c314683cf',
    V_TOKEN: '0xE476310751953E3aC32bbe4fc6218748fe02c4d2',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0xd6ff49B650550ce2452e0fCCa101Ab7CE206d851',
  },
  wrsETH: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0xe561FE05C39075312Aa9Bc6af79DdaE981461359',
    A_TOKEN: '0x41c7aCCC0fB97470bFB48014bad52E0d99447E79',
    V_TOKEN: '0xe5A29d07F3D532Cd16bD53376053C2aa5B320cB9',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x3acFddf27b85B5f773B610c6F7e4420aeB1Df8dD',
  },
  syrupUSDT: {
    decimals: 6,
    id: 10,
    UNDERLYING: '0xC4374775489CB9C56003BF2C9b12495fC64F0771',
    A_TOKEN: '0xD4eE376C40EdC83832aAaFc18fC0272660F5e90b',
    V_TOKEN: '0xDA5D1a9b7F515457638c01db13a18Bd3514fC4A6',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x0A3F8218a98337Ef37dCAE4F8a8cfaB0711C64cF',
  },
  WXPL: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0x6100E367285b01F48D07953803A2d8dCA5D19873',
    A_TOKEN: '0x5aA4bc74811D672DA5308019dA4779f673e60B47',
    V_TOKEN: '0x7ec35d7008682c33dBC6b214E01D919e8d441e48',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0xF932477C37715aE6657Ab884414Bd9876FE3f750',
  },
  PT_sUSDE_9APR2026: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0xab509448ad489e2E1341e25CC500f2596464Cc82',
    A_TOKEN: '0x53349cBeD7A3F851f0722Bf3Fa8f1b93fA939BeF',
    V_TOKEN: '0xA4408E7C8b5D4481a2D8aD7Aa89f3576a6A4a5D6',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x13f2EA8dfa948c5247826283079615Ee4d0A1AA5',
  },
  PT_USDe_9APR2026: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0x54Dc267be2839303ff1e323584A16e86CeC4Aa44',
    A_TOKEN: '0x9326fA5a71C93D5De313c91C3b80D74d0c3a0F5A',
    V_TOKEN: '0xA746feD5635787e2d97da1979c714BfcDf60fa1A',
    INTEREST_RATE_STRATEGY: '0x2B16E93bdB1897f517881B3c388bABD0C62C6cdC',
    ORACLE: '0x37f3a8b02BAbe4dd71acb5f214F22C09AFf607f3',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'USDe / USDT0',
    collateralBitmap: '2',
    collateralAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    borrowableBitmap: '1',
    borrowableAssets: ['0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '2': {
    label: 'USDe,sUSDe / USDT0',
    collateralBitmap: '6',
    collateralAssets: [
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
      '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
  '3': {
    label: 'weETH / WETH',
    collateralBitmap: '16',
    collateralAssets: ['0xA3D68b74bF0528fdD07263c60d6488749044914b'],
    borrowableBitmap: '32',
    borrowableAssets: ['0x9895D81bB462A195b4922ED7De0e3ACD007c32CB'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '4': {
    label: 'weETH / USDT0',
    collateralBitmap: '16',
    collateralAssets: ['0xA3D68b74bF0528fdD07263c60d6488749044914b'],
    borrowableBitmap: '1',
    borrowableAssets: ['0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7750,
    liquidationThreshold: 8000,
    liquidationBonus: 10750,
  },
  '5': {
    label: 'PT_USDe_15JAN2026 / USDT0,USDe',
    collateralBitmap: '64',
    collateralAssets: ['0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a'],
    borrowableBitmap: '3',
    borrowableAssets: [
      '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '6': {
    label: 'PT_USDe_15JAN2026 / USDe',
    collateralBitmap: '64',
    collateralAssets: ['0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a'],
    borrowableBitmap: '2',
    borrowableAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10110,
  },
  '7': {
    label: 'PT_sUSDE_15JAN2026 / USDT0,USDe',
    collateralBitmap: '128',
    collateralAssets: ['0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8'],
    borrowableBitmap: '3',
    borrowableAssets: [
      '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10300,
  },
  '8': {
    label: 'PT_sUSDE_15JAN2026 / USDe',
    collateralBitmap: '128',
    collateralAssets: ['0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8'],
    borrowableBitmap: '2',
    borrowableAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10200,
  },
  '9': {
    label: 'wrsETH / WETH,wstETH',
    collateralBitmap: '512',
    collateralAssets: ['0xe561FE05C39075312Aa9Bc6af79DdaE981461359'],
    borrowableBitmap: '288',
    borrowableAssets: [
      '0x9895D81bB462A195b4922ED7De0e3ACD007c32CB',
      '0xe48D935e6C9e735463ccCf29a7F11e32bC09136E',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '10': {
    label: 'wstETH / WETH',
    collateralBitmap: '256',
    collateralAssets: ['0xe48D935e6C9e735463ccCf29a7F11e32bC09136E'],
    borrowableBitmap: '32',
    borrowableAssets: ['0x9895D81bB462A195b4922ED7De0e3ACD007c32CB'],
    ltvzeroBitmap: '256',
    ltvzeroAssets: ['0xe48D935e6C9e735463ccCf29a7F11e32bC09136E'],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10100,
  },
  '11': {
    label: 'syrupUSDT / USDT0',
    collateralBitmap: '1024',
    collateralAssets: ['0xC4374775489CB9C56003BF2C9b12495fC64F0771'],
    borrowableBitmap: '1',
    borrowableAssets: ['0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
  '12': {
    label: 'WXPL / USDT0',
    collateralBitmap: '2048',
    collateralAssets: ['0x6100E367285b01F48D07953803A2d8dCA5D19873'],
    borrowableBitmap: '1',
    borrowableAssets: ['0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 5000,
    liquidationThreshold: 5500,
    liquidationBonus: 11000,
  },
  '13': {
    label: 'USDe,PT_USDe_15JAN2026,PT_USDe_9APR2026 / USDT0,USDe',
    collateralBitmap: '8258',
    collateralAssets: [
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
      '0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a',
      '0x54Dc267be2839303ff1e323584A16e86CeC4Aa44',
    ],
    borrowableBitmap: '3',
    borrowableAssets: [
      '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10340,
  },
  '14': {
    label: 'USDe,PT_USDe_15JAN2026,PT_USDe_9APR2026 / USDe',
    collateralBitmap: '8258',
    collateralAssets: [
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
      '0x93B544c330F60A2aa05ceD87aEEffB8D38FD8c9a',
      '0x54Dc267be2839303ff1e323584A16e86CeC4Aa44',
    ],
    borrowableBitmap: '2',
    borrowableAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9220,
    liquidationThreshold: 9420,
    liquidationBonus: 10240,
  },
  '15': {
    label: 'sUSDe,PT_sUSDE_15JAN2026,PT_sUSDE_9APR2026 / USDT0,USDe',
    collateralBitmap: '4228',
    collateralAssets: [
      '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
      '0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8',
      '0xab509448ad489e2E1341e25CC500f2596464Cc82',
    ],
    borrowableBitmap: '3',
    borrowableAssets: [
      '0xB8CE59FC3717ada4C02eaDF9682A9e934F625ebb',
      '0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10440,
  },
  '16': {
    label: 'sUSDe,PT_sUSDE_15JAN2026,PT_sUSDE_9APR2026 / USDe',
    collateralBitmap: '4228',
    collateralAssets: [
      '0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2',
      '0x02FCC4989B4C9D435b7ceD3fE1Ba4CF77BBb5Dd8',
      '0xab509448ad489e2E1341e25CC500f2596464Cc82',
    ],
    borrowableBitmap: '2',
    borrowableAssets: ['0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10240,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
